


































































































































































const AddQuestion = () => import("./components/addQuestion.vue");
import dataCenter from "@/request/requestIndex/index";
import { Component, Vue, Provide } from "vue-property-decorator";
import { QuestionParameter } from "@/pbjs/xcommon/ticket_pb";
import { pagnition } from "@/utils/commonConfig";
import { timeFormat } from "@/utils/index";
@Component({
  name: "orderDeal",
  components: { AddQuestion },
})
export default class CombinationProperty extends Vue {
  @Provide() private activeName: string = "first";
  @Provide() private resultData: any = [];
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private pagnition: any = pagnition;
  @Provide() private isLoanding: boolean = false;
  @Provide() private parameterValue: any = "";
  @Provide() private parameterOptions: any = [
    {
      value: "1",
      label: "0类问题",
    },
    {
      value: "2",
      label: "1类问题",
    },
    {
      value: "3",
      label: "2类问题",
    },
    {
      value: "10",
      label: "选项",
    },
  ];
  @Provide() private parameterKeyOptions: any = [
    {
      value: "2",
      label: "失效",
    },
    {
      value: "1",
      label: "有效",
    },
    {
      value: "3",
      label: "拒贷",
    },
    {
      value: "10",
      label: "无属性",
    },
  ];
  @Provide() private parameterKeyValue: any = ""; // 属性
  @Provide() private showAddToast: boolean = false;
  @Provide() private editData: any = {
    id: "", // 数据id
    qptype: "", // 参数类型
    value: "", // 参数值
    languageOneVal: "",
    translationOneVal: "",
    languageTwoVal: "",
    translationTwoVal: "",
    action: "", // 属性
    status: "",
  };
  @Provide() private title: any = "添加";

  private created() {
    this.queryResultList();
  }
  private formatDate(type: any, val: any) {
    let value = "";
    if (type == "type") {
      let obj = this.parameterOptions.find((item: any) => {
        return item.value == val;
      });
      value = obj.label;
    } else if (type == "value") {
      let obj = this.parameterKeyOptions.find((item: any) => {
        return item.value == val;
      });
      value = obj.label;
    }
    return value;
  }
  private queryResultList() {
    this.isLoanding = true;
    dataCenter.commonApi
      .queryQuestionListFn({
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        setQptype: this.parameterValue,
        setAction: this.parameterKeyValue,
      })
      .then(
        (res: any) => {
          console.log(res);
          if (res.commonout.code === 0) {
            this.isLoanding = false;
            this.pagerCount = res.pageout.total;
            res.listList.forEach((item: any, index: number) => {
              item.qpType = this.formatDate("type", item.qptype);
              item.actionFormat = this.formatDate("value", item.action);
              item.updateTime = timeFormat(Number(item.utime));
            });
            this.resultData = res.listList;
            console.log(this.resultData);
          } else {
            this.isLoanding = false;
          }
        },
        (oError: any) => {
          this.isLoanding = false;
        }
      );
  }
  private handleSizeChange(val: any) {
    console.log(val);
    this.pageSize = val;
    this.queryResultList();
  }
  private handleCurrentChange() {
    this.queryResultList();
  }
  private handlePrevChange() {
    this.queryResultList();
  }
  private handleNextChange() {
    this.queryResultList();
  }
  // 隐藏添加弹窗
  private returnRiskReport() {
    this.showAddToast = false;
  }
  private addQuestion() {
    this.editData = {
      id: "", // 数据id
      qptype: "", // 参数类型
      value: "", // 参数值
      languageOneVal: "",
      translationOneVal: "",
      languageTwoVal: "",
      translationTwoVal: "",
      action: "", // 属性
      reasonkey: "",
    };
    this.showAddToast = true;
    this.title = "添加";
  }
  private parameterValueChange(val: any) {
    console.log(val);
    this.parameterKeyValue = "";
    if (val == 10) {
      this.parameterKeyOptions = [
        {
          value: "2",
          label: "失效",
        },
        {
          value: "1",
          label: "有效",
        },
        {
          value: "3",
          label: "拒贷",
        },
      ];
    } else if (val == "") {
      this.parameterKeyOptions = [
        {
          value: "2",
          label: "失效",
        },
        {
          value: "1",
          label: "有效",
        },
        {
          value: "3",
          label: "拒贷",
        },
        {
          value: "10",
          label: "无属性",
        },
      ];
    } else {
      this.parameterKeyOptions = [
        {
          value: "10",
          label: "无属性",
        },
      ];
    }
  }
  private formatVal(val: any) {
    if (val) {
      return val.value || "--";
    } else {
      return "--";
    }
  }
  private editCombination(row: any) {
    let langLength = row.i18nList.length;
    console.log(row);
    this.editData.id = row.id + "";
    this.editData.qptype = row.qptype + "";
    this.editData.value = row.value;
    this.editData.languageOneVal = langLength >= 1 ? row.i18nList[0].lang : "";
    this.editData.translationOneVal = langLength >= 1 ? row.i18nList[0].value : "";
    this.editData.languageTwoVal = langLength >= 2 ? row.i18nList[1].lang : "";
    this.editData.translationTwoVal = langLength >= 2 ? row.i18nList[1].value : "";
    this.editData.action = row.action + "";
    this.editData.status = row.status;
    this.editData.reasonkey = row.reasonkey;
    this.showAddToast = true;
    this.title = "编辑";
  }
  private deleteData(row: any) {
    this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        let req2 = new QuestionParameter();
        req2.setId(row.id);
        req2.setQptype(row.qptype);
        dataCenter.commonApi
          .deleteQuestionDataFn({
            setData: req2,
          })
          .then(
            (res: any) => {
              console.log(res);
              if (res.code === 0) {
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
                this.queryResultList();
              }
            },
            (oError: any) => {
              console.log(oError);
            }
          );
      })
      .catch(() => {});
  }
  private updateList() {
    this.pageIndex = 1;
    this.parameterValue = "";
    this.parameterKeyValue = "";
    this.parameterKeyOptions = [
      {
        value: "2",
        label: "失效",
      },
      {
        value: "1",
        label: "有效",
      },
      {
        value: "3",
        label: "拒贷",
      },
      {
        value: "10",
        label: "无属性",
      },
    ];
    this.queryResultList();
  }
  private selectList() {
    this.pageIndex = 1;
    this.queryResultList();
  }
}
